import React from "react";
import { message, Popconfirm } from "antd";
import { gql, useMutation } from "@apollo/client";

const DELETEMESSAGE = gql`
  mutation removeMessage($id: ID!) {
    removeMessage(id: $id)
  }
`;

function DeleteMessage({ id, children, onDeleteMessage, closeDrawer }) {
  const [runDeleteMessage, deleteMessage] = useMutation(DELETEMESSAGE, {
    onCompleted({ removeMessage }) {
      
      if (removeMessage) {
        message.success(`پیام حذف شد.`);
        onDeleteMessage();
        closeDrawer();
      } 
    },
    onError(err) {
      console.log(err.message);
    },
  });

  const doDeleteMessage= () => {
    runDeleteMessage({
      variables: { id },
    });
  };
  return (
    <>
      <Popconfirm
        title={"حذف پیام"}
        okText="حذف"
        cancelText="خیر"
        onConfirm={doDeleteMessage}
      >
        <span>{children}</span>
      </Popconfirm>
    </>
  );
}

export default DeleteMessage;
